import { ExtractedContract } from "../types/contract.d";
import { getDisplayValue } from "./formatter";

export type CsvNormalizedDataItem = { id?: number; [key: string]: any };

export function buildCsvFileName(format: string): string {
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  return `export_${format}_${yyyy}${mm}${dd}.csv`;
}

export async function saveBlobAsFile(blob: Blob, suggestedName: string): Promise<void> {
  if (typeof window.showSaveFilePicker === "function") {
    const handle = await window.showSaveFilePicker({
      suggestedName,
      types: [{ description: "CSV File", accept: { "text/csv": [".csv"] } }],
    });
    const writable = await handle.createWritable();
    await writable.write(blob);
    await writable.close();
  } else {
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", suggestedName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }
}

export function formatCsvRows(
  data: CsvNormalizedDataItem[],
  columnDefs: { key: string; label: string }[],
  format: string
): Record<string, string>[] {
  return data.map((row) => {
    const newRow: Record<string, string> = {};
    columnDefs.forEach((col) => {
      if (format === "itandi") {
        newRow[col.key] = getDisplayValue(
          row as ExtractedContract,
          col.key as keyof ExtractedContract
        );
      } else {
        const value = row[col.key];
        newRow[col.key] = value !== null && value !== undefined ? String(value) : "N/A";
      }
    });
    return newRow;
  });
}
